import React, { useState } from 'react';

import { ModalFormSection, ModalV2 } from 'components/common/modals';
import { subscriptionsServices } from '@services';
import { showError } from '@utils';

import AddEditDriversForm from './AddEditDriversForm';

const AddDriverModal = ({
  open,
  onClose,
  subscriptionId,
  onGetSubscription,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      await subscriptionsServices.addDriver(subscriptionId, {
        ...values,
        role: Number(values.role),
      });
      onGetSubscription();
      onClose();
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalV2
      isOpen={open}
      onClose={onClose}
      isLoading={loading}
      title="Add Member"
    >
      <ModalFormSection>
        <AddEditDriversForm
          onSubmit={handleSubmit}
          onCancel={onClose}
          subscriptionId={subscriptionId}
        />
      </ModalFormSection>
    </ModalV2>
  );
};

export default AddDriverModal;
